<template>
  <v-dialog v-model="dialogOpen" :persistent="true" max-width="600px">
    <v-form>
      <v-card>
        <v-card-title>
          <h4><v-icon>mdi-car</v-icon>Fahrzeug</h4>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="shortName" label="Kurzbezeichnung" hint="Die Kurzbezeichnung wird vor der Bezeichnung angezeigt" />
          <v-text-field
            v-model="name"
            label="Bezeichnung"
            required
            :rules="rules"
          />
          <v-select
            :items="extraCharges"
            item-text="code"
            item-value="id"
            v-model="extraChargeId"
            label="Lohnart"
          />
          <v-checkbox v-model="isToolThatCanBeUsedWithAnyMachine" label="Kann ohne einem Fahrzeug verwendet werden" />
          <v-textarea label="Beschreibung" v-model="description" />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="default" text @click="close" :disabled="actionsDisabled">Abbrechen</v-btn>
          <v-btn v-if="isExistingMachine && machine.isActive" color="error" class="white--text" @click="setInactive" :loading="isChangingActive" :disabled="actionsDisabled">
            <v-icon>mdi-eye-off</v-icon> Deaktivieren
          </v-btn>
          <v-btn v-else-if="isExistingMachine" color="success" class="white--text" @click="setActive" :loading="isChangingActive" :disabled="actionsDisabled">
            <v-icon>mdi-eye</v-icon> Aktivieren
          </v-btn>
          <v-btn color="primary" @click="save" :disabled="!valid || actionsDisabled" :loading="isSaving">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import timeparkApi from "@/timeparkApi";
const machinesApi = timeparkApi.machinesApi;

export default {
  name: 'MachineDialog',
  props: {
    open: Boolean,
    machine: Object,
  },
  computed: {
    dialogOpen: {
      get() {
        return this.open;
      },
      set(v) {
        this.$emit('update:open', v);
      }
    },
    isChangingActive() {
      return this.runningOperation === 'changeActive';
    },
    isSaving() {
      return this.runningOperation === 'save';
    },
    actionsDisabled() {
      return !!this.runningOperation;
    },
    valid() {
      return !!this.name;
    },
    isExistingMachine() {
      return this.machine && this.machine.id;
    },
    extraCharges() {
      return [
        {
          id: null,
          code: ' - ',
        }
        ,
        ...this.$store.state.extraCharges
      ]
    },
  },
  watch: {
    machine: {
      deep: true,
      handler: 'updateData'
    }
  },
  methods: {
    async setInactive() {
      this.runningOperation = 'changeActive';

      await machinesApi.deactivateMachine(this.machine.id);
      await this.$store.dispatch('loadMachines');

      this.runningOperation = null;
      this.close();
    },
    async setActive() {
      this.runningOperation = 'changeActive';

      await machinesApi.reactivateMachine(this.machine.id);
      await this.$store.dispatch('loadMachines');

      this.runningOperation = null;
      this.close();
    },
    async save() {
      const machine = {
        id: this.machine ? this.machine.id : null,
        name: this.name,
        shortName: this.shortName,
        description: this.description,
        isToolThatCanBeUsedWithAnyMachine: this.isToolThatCanBeUsedWithAnyMachine,
        extraChargeId: this.extraChargeId
      };

      const apiOperation = machine.id ?
          machinesApi.editMachine :
          machinesApi.createMachine;
      this.runningOperation = 'save';

      await apiOperation(machine);
      await this.$store.dispatch('loadMachines');

      this.runningOperation = null;
      this.close();
    },
    close() {
      this.updateData(null);
      this.$emit('close');
    },
    updateData(data) {
      this.name = data ? data.name : '';
      this.shortName = data ? data.shortName : '';
      this.description = data ? data.description : '';
      this.isToolThatCanBeUsedWithAnyMachine = data ? data.isToolThatCanBeUsedWithAnyMachine : false;
      this.extraChargeId = data ? data.extraChargeId : null;
    },
  },
  data() {
    return {
      name: '',
      shortName: '',
      description: '',
      isToolThatCanBeUsedWithAnyMachine: false,
      extraChargeId: null,
      rules: [val => !!val || 'Dieses Feld darf nicht leer sein'],
      runningOperation: null,
    };
  },
};
</script>
